export default {
  title: "Reporte de Visitas"
  , tabla: {
    clave: "Clave"
    , fecha: "Fecha Contacto"
    , rep: "Rep"
    , estatus: "Estatus Comercio"
    , provincia: "Provincia"
    , localidad: "Localidad"
    , cp: "CP"
    , tipoform: "Tipo Canal"
    , tipo: "Tipo"
    , campana: "Campaña"
    , oob: "OOB"
    , estatuscorte: "Estatus Corte"
    , status: "Status"
    , substatus: "Sub Status"
    , base: "Base"
    , exclusion: "¿Fue excluida?"
    , vendor: "Vendor"
  }
  , filters: {
    fecha: "Fecha Contacto"
    , vendor: "Vendor"
    , rep: "Rep"
    , status: "Status"
    , substatus: "Sub Status"
    , provincia: "Provincia"
    , estatus: "Estatus Comercio"
    , exclusion: "Excluidas"
    , oob: "OOB"
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/reportes/reportevisitas.js